import Api from "@/services/api.service";

export default {
  updateProfile(object) {
    return Api().patch("user/profile", object);
  },
  getProfile() {
    return Api().get("user/profile");
  },
  removeProfileImage(object) {
    return Api().post("media/" + object.id, object.data);
  }
};
